import { type ClientRatingBreakdown } from "@fitness-app/data-models/entities/ClientRating";

export const clientRatingBreakdownLabels: Record<keyof ClientRatingBreakdown, string> = {
  workouts: "Treningi",
  bodyMeasurements: "Pomiary ciała",
  bodyPhotos: "Zdjęcia sylwetki",
  weightMeasurements: "Pomiary wagi",
  mealsTracked: "Posiłki",
  surveyAnswers: "Ankiety",
  consultations: "Konsultacje",
  messages: "Wiadomości",
  logins: "Logowania",
  habits: "Nawyki i zadania",
  challenges: "Wyzwania",
};
